import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

import { Item } from './Item';

export const ResourceHubLink = () => {
  return (
    <Item
      label="Resource Hub"
      path={
        'https://mwindustries.sharepoint.com/sites/MWIOnBoardingandTraining/SitePages/SNAP-Resources.aspx'
      }
      icon={faCircleQuestion}
      linkProps={{ target: '_blank' }}
    />
  );
};
